import React, { useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill'; // Importando o Quill
import 'react-quill/dist/quill.snow.css';
import { Container, Typography, TextField, Button, Box, Alert } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import './DashBoard.css';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module-react';
import MediaUploadField from './MediaUploadField';
 
 
const fonts = ['Arial', 'Verdana', 'Century Schoolbook', 'Times New Roman', 'Sans-serif'];
const fontNames = fonts.map(font => font.toLowerCase().replace(/\s/g, '-'));


// Registra o módulo
Quill.register('modules/imageResize', ImageResize);
const Font = Quill.import('formats/font');
Font.whitelist = fontNames;
Quill.register(Font, true);

const modules = {
    toolbar: [
        [{ font: fontNames }], // Adicionando as fontes
        [{ header: '1' }, { header: '2' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
    ],
    imageResize: {
        parchment: Quill.import('parchment'),
    },
};
const formats = [
    'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'strike',
    'color', 'background', 'align', 'link', 'image', 'blockquote', 'code-block'
];

const stripHtml = (value = '') =>
  String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const DashboardDivulgacaoCientifica = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        imagem: '', // URL da imagem
        titulo: '',
       
        conteudo: '', // 'conteudo' agora vai armazenar HTML formatado
        pdfLink: '', // Novo campo para o link do PDF
    });

    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false); // Para controlar o Snackbar
 
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const setFieldValue = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleUploadError = (message) => {
        setAlertMessage({ type: 'error', text: message });
        setOpenSnackbar(true);
    };
    const handleUploadSuccess = (message) => {
        setAlertMessage({ type: 'success', text: message });
        setOpenSnackbar(true);
    };

    // Função especial para capturar a alteração no campo 'conteudo'
    const handleConteudoChange = (value) => {
        setFormData({
            ...formData,
            conteudo: value, // O valor do editor Quill (com HTML) vai para 'conteudo'
        });
    };

    
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Obtenha o token antes de enviar
        const token = localStorage.getItem('token');  // ou outro método que você usa para armazenar o token
    
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Token não encontrado. Faça login novamente.' });
            setOpenSnackbar(true); // Mostrar mensagem de erro
            return;  // Impede o envio do formulário sem o token
        }

        const requiredFields = [
            ['Imagem de capa', formData.imagem],
            ['Título', formData.titulo],
            ['Conteúdo', formData.conteudo],
        ];
        const missing = requiredFields
            .filter(([, value]) => !stripHtml(value))
            .map(([label]) => label);

        if (missing.length) {
            setAlertMessage({
                type: 'error',
                text: `Preencha os campos obrigatórios: ${missing.join(', ')}.`,
            });
            setOpenSnackbar(true);
            return;
        }
    
        try {
            // Enviar o formulário para a API do backend com o token
            const response = await axios.post(
                `${apiUrl}/artigos`, 
                {
                    imagens: [formData.imagem],  // Enviar a imagem como um array
                    titulo: formData.titulo,
                    arquivoDownload: formData.pdfLink, // Enviar o link do PDF
                    conteudo: formData.conteudo,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Envia o token no cabeçalho Authorization
                    }
                }
            );
          
            setAlertMessage({ type: 'success', text: 'Matéria adicionada com sucesso!' });
            setOpenSnackbar(true); // Mostra a mensagem de sucesso
            setFormData({
                imagem: '',
                titulo: '',
                 
               
                conteudo: '',
                pdfLink: '', // Limpa o campo do link do PDF
            });
        } catch (error) {
            const backendMessage = error?.response?.data?.error || error?.response?.data?.message;
            setAlertMessage({ type: 'error', text: backendMessage || 'Erro ao adicionar matéria. Tente novamente.' });
            setOpenSnackbar(true); // Mostra a mensagem de erro
        }
    };
    
    
    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Container maxWidth="lg">
    <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
                
                <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
                <Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                    fontFamily: "'Lato', serif",
                    color: "black",
                    borderBottom: "4px solidrgb(8, 8, 7)",
                    paddingBottom: "10px",
                    textTransform: "uppercase",
                    borderBottom: "4px solid #d4af37",
                    animation: "glow 2s infinite alternate",
                    marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
            >    Painel de Divulgação Científica
</Typography>
    
                <form onSubmit={handleSubmit}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Adicionar novo Artigo 
                    </Typography>
  
                    <Box mb={3}>
                        <MediaUploadField
                            label="Imagem de capa do artigo"
                            name="imagem"
                            value={formData.imagem}
                            onChange={setFieldValue}
                            folder="artigos"
                            accept="image/*"
                            required
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>
  
                    <Box mb={3}>
                        <TextField
                            fullWidth
                            label="Título"
                            variant="outlined"
                            name="titulo"
                            value={formData.titulo }
                            onChange={handleChange}
                            required
                        />
                    </Box>
 
                  

                     

                    <Box mb={3}>
                        <MediaUploadField
                            label="PDF do artigo (opcional)"
                            name="pdfLink"
                            value={formData.pdfLink}
                            onChange={setFieldValue}
                            folder="artigos"
                            accept=".pdf,application/pdf"
                            onError={handleUploadError}
                            onSuccess={handleUploadSuccess}
                        />
                    </Box>
  
                    <Box mb={5} sx={{ width: '100%', maxWidth: '1200px', height: '900px', margin: '0 auto' }}>
    <Typography variant="body1" gutterBottom>
        Matéria ou Artigo:
    </Typography>
    <ReactQuill
        value={formData.conteudo}
        onChange={handleConteudoChange}
        theme="snow"
        modules={modules}
        formats={[
            'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'strike',
            'color', 'background', 'align', 'link', 'image', 'blockquote', 'code-block'
        ]}
        style={{ height: '800px' }}  // Definindo altura para 900px
    />
</Box>



                    <Button fullWidth variant="contained" color="primary" type="submit">
                        Enviar
                    </Button>
  
                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={6000}
                        onClose={handleCloseSnackbar}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    >
                        <Alert onClose={handleCloseSnackbar} severity={alertMessage.type || 'info'} sx={{ width: '100%' }}>
                            {alertMessage.text}
                        </Alert>
                    </Snackbar>
                </form>
            
        </Container>
    );
};

export default DashboardDivulgacaoCientifica;
